import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ROAD_READY_SITE_URL } from '../utils/roadReadySite';

// Sends a retired /founding-partner/* or /road-ready-network URL to its
// equivalent on the Road Ready site, keeping the query string (e.g. ?email=,
// directory filters) and the claim token, so old emails/bookmarks still work.
export default function RoadReadyRedirect({ to }) {
  const { search } = useLocation();
  const { token } = useParams();
  const path = token ? to.replace(':token', encodeURIComponent(token)) : to;
  const target = `${ROAD_READY_SITE_URL}${path}${search}`;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <p style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
      Redirecting to <a href={target}>Road Ready Network™</a>…
    </p>
  );
}
